import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class ProductSearchForm extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/product-search-form';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetProductSearchForms';

    static model_name = 'ProductSearchForm';

    static fields() {
		return {
			id: this.attr(null),
			title: this.attr(null),
			country_id: this.attr(null),
			website_category_id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
